






































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import InformationCard from "@/components/InformationCard.vue";
import InformationCardValues from "@/components/InformationCardValues.vue";
import { AZNCONNECT_API } from "@/services/aznconnect-api";
import { ProfessionalSummaryDetailsModel } from "@/types/aznconnect_api";
import moment from "moment";
import SessionOpenedViewModel from "@/models/security/zorgID/sessionOpenedViewModel";

import MeasuredValuesView from "@/components/professionalsummary/MeasuredValuesView.vue";
import AlertsView from "@/components/professionalsummary/AlertsView.vue";
import AllergyIntolerancesView from "@/components/professionalsummary/AllergyIntolerancesView.vue";
import EncountersView from "@/components/professionalsummary/EncountersView.vue";
import SubstanceAdministrationView from "@/components/professionalsummary/SubstanceAdministrationView.vue";
import ContactReportsView from "@/components/professionalsummary/ContactReportsView.vue";
import ConcernEpisodeView from "@/components/professionalsummary/ConcernEpisodeView.vue";
import RawMessageView from "@/components/professionalsummary/RawMessageView.vue";
import MetaDataView from "@/components/professionalsummary/MetaDataView.vue";
import LogonComponent from "@/components/zorgID/LogonComponent.vue";
import RequestConsentDialog from "@/components/professionalsummary/RequestConsentDialog.vue";
import { SecurityService } from "@/services/SecurityService";

interface PsUnavailableInfo {
  title: string;
  message: string;
  // Whether the "vraag toestemming aan" card should also be offered - only
  // relevant when there's genuinely no PS data, not for technical LSP errors.
  offerConsentRequest: boolean;
}

@Component({
  components: {
    "meta-data-view": MetaDataView,
    "raw-message-view": RawMessageView,
    "information-card": InformationCard,
    "information-card-values": InformationCardValues,
    "measured-values-view": MeasuredValuesView,
    "alerts-view": AlertsView,
    "allergy-intolerances-view": AllergyIntolerancesView,
    "encounters-view": EncountersView,
    "substance-administration-view": SubstanceAdministrationView,
    "contact-reports-view": ContactReportsView,
    "concern-episode-view": ConcernEpisodeView,
    "logon-zorgid-component": LogonComponent,
    RequestConsentDialog,
  },
})
export default class DetailPane extends Vue {
  @Prop({ default: null })
  referral!: any;

  @Prop({ default: false })
  advancedMode!: boolean;

  @Prop({ default: false })
  developerMode!: boolean;

  showDialog: boolean = false;
  mitzConsentRequested: boolean = false;
  psUnavailableInfo: PsUnavailableInfo | null = null;
  patienReferenceIsAvailable: boolean = false;
  patientReferenceIsValid: boolean = true; // Assuming valid by default, unless LSP responds otherwise
  authenticatedWithUziPas: boolean = false;
  noPermissionWithUziPas: boolean = false;
  psModel: any = {};
  psIsReady: boolean = false;
  validationMessages: Array<string> = [];
  errorMessages: Array<string> = [];

  loading: boolean = true;

  securityServiceInstance = SecurityService.getInstance();

  private created() {
    this.subscribeToEvents();
  }

  private subscribeToEvents(): void {
    var me = this;
    SecurityService.getInstance().subscribeSessionOpenedReceived(x => {
      me.sessionOpened(x);
    });
  }

  private sessionOpened(sessionOpenedViewModel: SessionOpenedViewModel) {
    this.authenticatedWithUziPas = !sessionOpenedViewModel.IsCancelled;
    //Test BSN again and load or request new PS
    this.validatePatientReferenceLength();
    this.noPermissionWithUziPas = false;
    this.loadDetails();
    this.loadRequestedMitzConsent();
  }

  mounted() {
    this.validatePatientReferenceLength();
    this.validateAuthenticationUZIPas();
    this.loadDetails();
    this.loadRequestedMitzConsent();
  }

  openRequestConsentDialog() {
    this.showDialog = true;
  }

  consentRequested() {
    this.mitzConsentRequested = true;
    this.requestNewPS();
  }

  validatePatientReferenceLength(): void {
    const vm = this;

    if (vm.referral && vm.referral.PatientBSN) {
      var bsn = vm.referral.PatientBSN;

      if (bsn.length == 9) {
        vm.patienReferenceIsAvailable = true;
      }
    }
  }

  validateAuthenticationUZIPas(): void {
    this.authenticatedWithUziPas = SecurityService.getInstance().isLoggedOn();
  }

  getPsUnavailableInfo(
    psModel: ProfessionalSummaryDetailsModel,
  ): PsUnavailableInfo | null {
    const bsn = this.referral ? this.referral.PatientBSN : "";

    switch (psModel && psModel.QueryResponseCode) {
      case "NF":
        return {
          title: "Geen gegevens gevonden",
          message: `De professionele samenvatting is op ${moment(psModel.ResponseDate).format("DD-MM-YYYY HH:mm")} succesvol opgevraagd, maar er zijn geen medische gegevens gevonden voor patiënt met BSN: ${bsn}. Probeer het eventueel opnieuw.`,
          offerConsentRequest: true,
        };
      case "AE":
        return {
          title: "Fout bij het ophalen van de professionele samenvatting",
          message:
            "Het Landelijk Schakelpunt heeft een technische fout gemeld bij het verwerken van deze aanvraag. Probeer het later opnieuw.",
          offerConsentRequest: false,
        };
      case "QE":
        return {
          title: "Ongeldige aanvraag",
          message:
            "De aanvraag voor de professionele samenvatting bevatte ongeldige gegevens en kon niet worden verwerkt door het Landelijk Schakelpunt.",
          offerConsentRequest: false,
        };
      default:
        return null;
    }
  }

  /**
   * Shared "nothing to show" info for cases where we never even got a parseable PS response:
   * no stored message yet, or a technical failure while requesting one from the LSP.
   */
  psNotFoundInfo(): PsUnavailableInfo {
    const bsn = this.referral ? this.referral.PatientBSN : "";

    return {
      title: "Professionele samenvatting niet beschikbaar",
      message: `Er is geen Professionele samenvatting gevonden voor patiënt met BSN: ${bsn}`,
      offerConsentRequest: true,
    };
  }

  get psResponseIsStale(): boolean {
    var todayMinusHours = moment().subtract(1, "hours");
    var responseDate = moment(this.psModel.ResponseDate);

    return responseDate.isSameOrBefore(todayMinusHours);
  }

  requestNewPS() {
    const vm = this;

    vm.loading = true;

    this.validateAuthenticationUZIPas();

    if (this.authenticatedWithUziPas) {
      var UZIPasNumber = SecurityService.getInstance().uziNumber;
      var UziRegisterSubscriberNumber = SecurityService.getInstance()
        .uziRegisterSubscriberNumber;

      AZNCONNECT_API.get("/ProfessionalSummary/RequestPs", {
        params: {
          patientId: vm.referral.PatientId,
          patientReference: vm.referral.PatientBSN,
          UZIPasNumber: UZIPasNumber,
          UziRegisterSubscriberNumber: UziRegisterSubscriberNumber,
        },
      }).then(
        function(response) {
          var psObj = response.data as ProfessionalSummaryDetailsModel;
          vm.psModel = psObj;
          vm.psUnavailableInfo = vm.getPsUnavailableInfo(psObj);

          if (vm.psUnavailableInfo) {
            // Handled by the unified "psUnavailableInfo" template branch
          } else if (
            vm.psModel &&
            vm.psModel.AcknowledgementDetails.length > 0
          ) {
            vm.noPermissionWithUziPas = true;
          } else if (
            vm.psModel &&
            vm.psModel.ProfessionalSummaryOrganizationsAndPatients &&
            vm.psModel.ProfessionalSummaryOrganizationsAndPatients.length == 0
          ) {
            vm.psUnavailableInfo = vm.psNotFoundInfo();
          } else {
            vm.noPermissionWithUziPas = false;
            vm.psIsReady = true;
          }

          vm.loading = false;
        },
        function(error) {
          var responseMessage = error.response.data.Message;

          if (responseMessage == "UZIAuthenticationFailed") {
            vm.authenticatedWithUziPas = false;
          }

          if (responseMessage == "PSNotFoundException") {
            vm.psUnavailableInfo = vm.psNotFoundInfo();
          }

          if (responseMessage == "PatientReferenceInvalid") {
            vm.patientReferenceIsValid = false;
          }

          // error callback
          vm.psIsReady = false;
          vm.loading = false;
        },
      );
    } else {
      vm.psIsReady = false;
      vm.loading = false;
      vm.noPermissionWithUziPas = false;
    }
  }

  loadRequestedMitzConsent() {
    const vm = this;

    vm.loading = true;

    AZNCONNECT_API.get("/Mitz/ValidateConsent", {
      params: {
        patientId: vm.referral.PatientId,
      },
    }).then(
      function(response) {
        var mitzConsent = response.data as boolean;
        vm.mitzConsentRequested = mitzConsent;
        vm.loading = false;
      },
      function() {
        //nothing
        vm.loading = false;
      },
    );
  }

  loadDetails() {
    const vm = this;

    vm.loading = true;

    AZNCONNECT_API.get("/ProfessionalSummary/get", {
      params: {
        PatientId: vm.referral.PatientId,
      },
    }).then(
      function(response) {
        var psObj = response.data as ProfessionalSummaryDetailsModel;
        vm.psModel = psObj;
        vm.psUnavailableInfo = vm.getPsUnavailableInfo(psObj);

        if (vm.psUnavailableInfo) {
          // Handled by the unified "psUnavailableInfo" template branch
        } else if (vm.psModel && vm.psModel.AcknowledgementDetails.length > 0) {
          vm.noPermissionWithUziPas = true;
        } else if (
          vm.psModel &&
          vm.psModel.ProfessionalSummaryOrganizationsAndPatients &&
          vm.psModel.ProfessionalSummaryOrganizationsAndPatients.length == 0
        ) {
          vm.psUnavailableInfo = vm.psNotFoundInfo();
        } else {
          vm.noPermissionWithUziPas = false;
          vm.psIsReady = true;
        }

        vm.loading = false;
      },
      function() {
        //PS not found, check if authenticated, then automatically request a new one
        if (vm.authenticatedWithUziPas) {
          vm.requestNewPS();
        } else {
          // error callback
          vm.psIsReady = false;
          vm.loading = false;
          vm.psUnavailableInfo = vm.psNotFoundInfo();
        }
      },
    );
  }
}
